export default __webpack_public_path__ + "static/media/Eye.78a9ec7f.svg";